import { Dropdown } from "@modernatx/ui-kit-react";
import React from "react";

interface YearFilterProps {
  value: number;
  onChange: (year: number) => void;
  startYear?: number;
}

const DEFAULT_START_YEAR = 2024;

export const YearFilter: React.FC<YearFilterProps> = ({
  value,
  onChange,
  startYear = DEFAULT_START_YEAR
}) => {
  const currentYear = new Date().getFullYear();
  // Generate years from currentYear down to startYear
  const options = Array.from({ length: currentYear - startYear + 1 }).map(
    (_, i) => {
      const year = currentYear - i;
      return {
        label: `${year}-${year + 1}`,
        value: year.toString()
      };
    }
  );

  const handleSelect = (option: {
    label: string;
    value: string | number | null;
  }) => {
    if (option.value !== null) {
      onChange(Number(option.value));
    }
  };

  const defaultOption =
    options.find((opt) => Number(opt.value) === value) || options[0];

  return (
    <Dropdown
      label="Select Year"
      dropdownOptions={options}
      defaultOption={defaultOption}
      onSelectOption={handleSelect}
    />
  );
};
